import { defineElement, FC, onDidLoad, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { ButtonA } from '@atoms/button/button';
import { Flyin } from '@molecules/fly-in/fly-in';
import { Image } from '@source/components/atoms/image';
import { openFlyin } from '@source/store/flyins';
import { useStylesheet } from '@utilities/hooks';
import cookies from 'js-cookie';

import style from './flyin-update.scss';

const HIDDEN_CLASS = 'u-sr-only';
const FLYIN_ID = 'flyin-update';

export const FlyinUpdate: FC = ({ element }) => {
    const [flyinCookie] = useProp<string>('flyinCookie');
    const [flyinLabel] = useProp<string>('flyinLabel');
    const [flyinButtonLabel] = useProp<string>('flyinButtonLabel', '');
    const [flyinButtonLink] = useProp<string>('flyinButtonLink', '');
    const [flyinCardTitle] = useProp<string>('flyinCardTitle', '');
    const [flyinCardImage] = useProp<string>('flyinCardImage', '');

    useStylesheet(style);

    onDidLoad(() => {
        renderFlyin();

        const cookie = cookies.get(flyinCookie);
        if (!cookie) setTimeout(() => openFlyin(FLYIN_ID), 300);
    });

    function onFlyinClose() {
        cookies.set(flyinCookie, 'true', { expires: 365 });
    }

    function renderFlyin() {
        const children = [...element.childNodes];
        element.innerHTML = '';

        element.append(
            <Flyin id={FLYIN_ID} label={flyinLabel} onClose={onFlyinClose}>
                <div class="flyin-update__card">
                    {flyinCardImage && (
                        <Image
                            image={flyinCardImage}
                            alt={flyinCardTitle}
                            preload={{
                                width: 16,
                                height: 11,
                            }}
                            settings={{
                                '640w': {
                                    width: 320,
                                    height: 220,
                                },
                            }}
                            objectFit={true}
                        />
                    )}
                    <div class="flyin-update__content">
                        {flyinCardTitle && <p class="u-h4 u-margin-bottom-1">{flyinCardTitle}</p>}
                        <div class="flyin-update__text-content s-rich-text u-margin-bottom-1">
                            {children}
                        </div>
                        {flyinButtonLabel && (
                            <ButtonA label={flyinButtonLabel} url={flyinButtonLink} />
                        )}
                    </div>
                </div>
            </Flyin>,
        );

        element.classList.remove(HIDDEN_CLASS);
    }
};

FlyinUpdate.props = {
    flyinCookie: {
        type: String,
        required: true,
    },
    flyinLabel: {
        type: String,
        required: true,
    },
    flyinButtonLabel: {
        type: String,
    },
    flyinButtonLink: {
        type: String,
    },
    flyinCardTitle: {
        type: String,
    },
    flyinCardImage: {
        type: String,
    },
};

defineElement('bpd-flyin-update', FlyinUpdate);
